exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-filters[data-v-6ea1dfc1] {\n  margin: 28px 0 20px;\n}\n.list-filter[data-v-6ea1dfc1] {\n  font-weight: 500;\n}\n.search-icon[data-v-6ea1dfc1] {\n  display: none;\n  color: rgba(0, 0, 0, 0.6);\n  font-size: 24px;\n  position: relative;\n  top: 6px;\n  margin-left: 16px;\n}\n.filter-by[data-v-6ea1dfc1] {\n  margin-left: 4px;\n}\n.filter-by[data-v-6ea1dfc1] {\n  margin-right: 12px;\n}\n", ""]);

// exports
